import type { CustomCellRendererProps } from "ag-grid-react";
import { defineColumn, transferRowDataInternal } from "presentation/view/components/TableWrapper/BasicTableConstants";
import { MovementPatternConstant } from "./MovementPatternConstant";

const MOVEMENT_PATTERN_CONSTANT = MovementPatternConstant.Table;
let dateFieldList: string[] = [];
let dateTimeFieldList: string[] = [];
export const INITIAL_MOVEMENT_PATTERN_DTL_COL_DEF: any[] = [

    // {
    //     headerName: MOVEMENT_PATTERN_CONSTANT.PRIORITY,
    //     field: "seq",
    //     enableRowGroup: false,
    //     enablePivot: true,
    //     enableValue: false,
    //     rowGroup: false,
    //     filter: true,
    //     width: 150,
    //     pinned: "left",
    //     checkboxSelection: true,
    //     headerCheckboxSelection: true,
    // },
    {
        headerName: MOVEMENT_PATTERN_CONSTANT.CON_STATUS,
        field: "cntrStatus",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 200,
        checkboxSelection: true,
        headerCheckboxSelection: true,
    },
    {
        headerName: MOVEMENT_PATTERN_CONSTANT.MOVEMENT_IND,
        field: "movementCode",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 150,
    },
    {
        headerName: MOVEMENT_PATTERN_CONSTANT.OT_FROM,
        field: "fromOtChargeInd",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 150,
    },
    {
        headerName: MOVEMENT_PATTERN_CONSTANT.OT_TO,
        field: "toOtChargeInd",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 150,
    },

].map((col, index) => {
    const cellRenderers: { [key: string]: ((params: CustomCellRendererProps) => {}) } = {};

    return defineColumn(col, index, dateFieldList, dateTimeFieldList, [], cellRenderers);
});

export const transferRowData = (data: any[]) => {
    const externalFnctions: { [key: string]: ((fieldName: string, row: any) => {}) } = {};

    return transferRowDataInternal(data, dateFieldList, dateTimeFieldList, [], externalFnctions);
}